// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');

const initialState = Immutable.fromJS({
    checkStatus: 0,
    isFetchingCheckStatus: false,
    checkStatusFetched: false,
    error: null,
});

const RACheckStatus = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_CHECK_STATUS_REQUEST:
            return state.set('isFetchingCheckStatus', true);
        case actionTypes.RA_CHECK_STATUS_SUCCESS:
            return state.merge({
                checkStatus: action.payload,
                checkStatusFetched: true,
                isFetchingCheckStatus: false,
            });
        case actionTypes.RA_CHECK_STATUS_FAILURE:
            return state.merge({
                checkStatusFetched: true,
                error: action.payload,
                isFetchingCheckStatus: false,
            });
        default:
            return state;
    }
};

module.exports = RACheckStatus;
